module.exports = __webpack_public_path__ + "img/logo-2.b3128c9a.png";